/*
 * Copyright (c) 2025-2026.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React, {Component} from 'react';
import {Database} from "../APIClient.jsx";
import RowDataTable from "./RowDataTable.jsx";
import DisplayIcon from "./Icons/DisplayIcon.jsx";
import ElementStatus from "./ElementStatus.jsx";
import {UI} from "../UIGenerator.jsx";
import EmptyStateBig from "./EmptyState/EmptyStateBig.jsx";
import TextElement from "./TextElement.jsx";
import ButtonComponent from "./BasicInputs/ButtonComponent.jsx";
import {Socket} from "../Socket.js";
import {Subscription} from "../Subscription.js";
import {Util} from "../Utilities.js";
import OutputList from "./OutputList/OutputList.jsx";
import OutputListItem from "./OutputList/OutputListItem.jsx";
import {Backups} from "../Objects/Backups.jsx";
import {format} from "date-fns";
import DisplayStateHistory from "./DisplayStateHistory.jsx";

class ElementBackups extends Component {
    constructor() {
        super();
        this.state = {
            allBackups: []
        }
        this.sub = new Subscription()
    }

    async fetchData() {
        let {elementId} = this.props
        let allBackups = await Database.table("Backups", "app").simpleFilter("elementId", elementId)
        this.setState({allBackups: allBackups.recordset})

        this.sub.add(() => Database.table("Backups", "app").onChange((change) => {
            let allBackups = this.state.allBackups
            allBackups = Socket.applyChange(allBackups, change)

            this.setState({allBackups: allBackups})
        }, [{
            column: "targetIndexKey",
            value: elementId
        }]), "liveData")
    }

    componentDidMount() {
        this.fetchData()
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.elementId !== this.props.elementId) {
            this.fetchData()
        }
    }

    componentWillUnmount() {
        this.sub.unmount()
    }

    backupInfo(domain) {
        UI.drawer(Util.unique.newInternalId(), (state, setState, close) => {
            return (<div className={"p-2"}>
                <OutputList>
                    <OutputListItem titel={"indexKey"}>
                        <span>{domain.indexKey}</span>
                    </OutputListItem>
                    <OutputListItem titel={"backupName"}>
                        <span>{domain.backupName}</span>
                    </OutputListItem>
                    <OutputListItem titel={"backupPath"}>
                        <span>{domain.backupPath}</span>
                    </OutputListItem>
                    <OutputListItem titel={"elementId"}>
                        <span>{domain.elementId}</span>
                    </OutputListItem>
                    <OutputListItem titel={"status"}>
                        <span>{domain.status}</span>
                    </OutputListItem>
                    <OutputListItem titel={"backupSize"}>
                        <span>{domain.backupSize}</span>
                    </OutputListItem>
                    <OutputListItem titel={""}>
                        <ButtonComponent
                            text={"Apply backup"}
                            onClick={async () => {
                                if (this.props.applyBackup !== undefined) {
                                    await this.props.applyBackup(domain.indexKey)
                                }

                                await this.fetchData()
                                close()
                            }}></ButtonComponent>


                    </OutputListItem>
                    <DisplayStateHistory name={"Volumes"} elementId={domain.indexKey}/>

                </OutputList>
            </div>)

        }, (state, close) => {
            close()
        }, {
            title: "Edit Backup", button: [{
                type: "abort",
                text: "Abbrechen",
                onClick: (inputState, setState, close) => {
                    close()
                }
            }]
        }).open()


    }

    render() {
        let {allBackups} = this.state
        return (
            <div>
                <div className={"mt-2"}>
                    <RowDataTable
                        selectedIndex={this.state.selectedIndex}
                        iconElement={(row) => {
                            return (<div
                                className={`flex-shrink-0  p-1 flex justify-center items-center rounded  border mr-3 `}>
                                <DisplayIcon iconName={"Backup"} size={"1.1rem"}/>
                            </div>)
                        }}
                        buttons={(row) => {
                            return <>


                                <ElementStatus name={"Backups"} elementId={row.indexKey}/>

                            </>

                        }}
                        data={allBackups.sort((a, b) => (b.timestamp - a.timestamp)).map(item => ({
                            ...item,
                            Name: <><p
                                className={"max-w-64 truncate"}>{item.backupName} </p> {format(item.timestamp * 1000, "dd.MM.yyyy")} </>

                        }))}
                        emptyState={() => {
                            return (<><EmptyStateBig iconName={"IoIosSearch"}
                                                     text={<div className={"w-96 space-y-3"}>
                                                         <TextElement
                                                             textType={"header-lg"}> Keine test mit
                                                             dem Namen: "<span
                                                                 className={"italic"}>{this.state.searchinput}</span>"
                                                             gefunden</TextElement>

                                                         <ButtonComponent iconName={"IoAdd"}
                                                                          onClick={() => {
                                                                              //AppActions.layout.newLayout()
                                                                          }}
                                                                          text={`Neue  `}/>
                                                     </div>}/></>)

                        }}
                        progressPending={!this.state.isLoadedComplete}
                        onRowClicked={(data) => {
                            this.backupInfo(data)
                        }}
                        onMiddleMouseClick={(data) => {
                        }}
                    />
                </div>


            </div>
        );
    }
}

ElementBackups.propTypes = {};

ElementBackups.defaultProps = {};


export default ElementBackups;